import React from 'react';
import { Card, Avatar, Badge } from 'antd';
import { UserOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { IUser } from '../../types/user';

interface ProfileProps {
  user: IUser;
}

export const Profile: React.FC<ProfileProps> = ({ user }) => {
  return (
    <Card
      hoverable
      cover={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '20px 0',
          }}>
          <Badge
            count={user.isVerified ? <CheckCircleOutlined style={{ color: '#52c41a' }} /> : null}>
            <Avatar size={100} icon={<UserOutlined />} />
          </Badge>
        </div>
      }>
      <Card.Meta
        title={<div style={{ fontSize: '1.5em', fontWeight: 'bold' }}>{user.name}</div>}
        description={
          <>
            <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
              <strong>Email:</strong> {user.email}
            </div>
            <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
              <strong>Date of registration:</strong>{' '}
              {new Date(+user.createdAt).toLocaleDateString()}
            </div>
          </>
        }
      />
    </Card>
  );
};
